var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 16C5.1943 16.0004 5.05872 15.9567 4.946 15.8753L0.279333 12.542C0.193021 12.4804 0.122652 12.3991 0.0740706 12.3048C0.0254889 12.2105 9.58507e-05 12.106 0 12L0 0.666667C0 0.489856 0.0702379 0.320286 0.195262 0.195262C0.320286 0.0702379 0.489856 0 0.666667 0C0.925333 0 1.45667 0.416 1.544 0.478667L5.72133 3.46667C5.8078 3.52855 5.87821 3.61021 5.92668 3.70485C5.97516 3.79948 6.0003 3.90434 6 4.01067V15.3333C6.00013 15.4559 5.96647 15.5761 5.90272 15.6808C5.83898 15.7855 5.74761 15.8705 5.63867 15.9267C5.54401 15.9746 5.43944 15.9997 5.33333 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 8.66699V12.667H9.33334C9.51015 12.667 9.67972 12.5968 9.80475 12.4717C9.92977 12.3467 10 12.1771 10 12.0003V8.66699H7.33334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 4.01067V4.66667H9.99999V0.666667C9.99999 0.489856 9.92976 0.320286 9.80473 0.195262C9.67971 0.0702379 9.51014 0 9.33333 0L3.16733 0L6.50066 2.384C6.75819 2.56998 6.96794 2.81439 7.11269 3.09716C7.25743 3.37993 7.33305 3.693 7.33333 4.01067Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.66634L12 3.33301V5.99967H7.33334V7.33301H12V9.99967L16 6.66634Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.45168c37637050c9468325c7350d6f0c.svg";
export { ForwardRef as ReactComponent };